<button mat-button [matMenuTriggerFor]="userMenu" [ngClass]="['theme-' + theme]" data-userflow="account-menu-button">
    <div fxLayout="row" fxLayoutAlign="center center">
        <div class="b-avatar">
            <img *ngIf="userAvatarUrl; else nameAbbr" [src]="userAvatarUrl" class="image" />

            <ng-template #nameAbbr>
                <span class="name-abbr">{{ userNameAbbr }}</span>
            </ng-template>
        </div>
        <mat-icon class="s-12 mx-4" svgIcon="dropdown"></mat-icon>
    </div>
</button>

<mat-menu
    #userMenu="matMenu"
    [overlapTrigger]="false"
    class="u-dropdown global-account-menu-dropdown {{ 'theme-' + theme }}"
>
    <div fxLayout="row" fxLayoutAlign="start center" class="header">
        <div class="b-avatar">
            <img *ngIf="userAvatarUrl; else nameAbbr" [src]="userAvatarUrl" class="image" />

            <ng-template #nameAbbr>
                <span class="name-abbr">{{ userNameAbbr }}</span>
            </ng-template>
        </div>
        <div>
            <span class="account-name">{{ userName }}</span>
            <span class="account-role">{{ userRole }}</span>
        </div>
    </div>

    <button
        mat-menu-item
        (click)="openUserSettings()"
        matTooltip="Open user settings"
        [matTooltipPosition]="'left'"
        fxLayout="row"
        fxLayoutAlign="space-between center"
    >
        <span fxFlex>User settings</span>
        <mat-icon class="s-16" matButtonIcon iconPositionEnd svgIcon="settings"></mat-icon>
    </button>

    <button
        *ngIf="showEmailNotifications"
        mat-menu-item
        (click)="openEmailNotificationsSettings()"
        matTooltip="Open email notification settings"
        [matTooltipPosition]="'left'"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        data-userflow="email-notifications-button"
    >
        <span fxFlex>Email notifications</span>
        <mat-icon class="s-16" matButtonIcon iconPositionEnd svgIcon="alarm"></mat-icon>
    </button>

    <button
        *ngIf="showAccountSettings"
        mat-menu-item
        (click)="openAMU()"
        matTooltip="Open account Management"
        [matTooltipPosition]="'left'"
        aria-label="Account Management Button"
        fxLayout="row"
        fxLayoutAlign="space-between center"
    >
        <span fxFlex>Account settings</span>
        <mat-icon class="s-16" iconPositionEnd svgIcon="settings"></mat-icon>
    </button>

    <button
        *ngIf="showSubscriptionPlans"
        mat-menu-item
        (click)="openSubscriptionPlans()"
        matTooltip="Open subscription plans"
        [matTooltipPosition]="'left'"
        fxLayout="row"
        fxLayoutAlign="space-between center"
    >
        <span fxFlex>Subscription plans</span>
        <mat-icon class="s-16" iconPositionEnd svgIcon="finance"></mat-icon>
    </button>

    <button *ngIf="showMarkModeToggle" mat-menu-item fxLayout="row" fxLayoutAlign="space center">
        <mat-slide-toggle
            [checked]="markModeEnabled"
            (change)="onMarkModeStateChanged($event)"
            (click)="onSwitchMarkModeStateClicked($event)"
        >
            <span>Skip mode</span>
        </mat-slide-toggle>
    </button>

    <button
        *ngIf="showLogout"
        mat-menu-item
        (click)="onLogoutClick()"
        fxLayout="row"
        fxLayoutAlign="space-between center"
    >
        <span fxFlex>Logout</span>
        <mat-icon class="s-16" iconPositionEnd svgIcon="logout"></mat-icon>
    </button>
</mat-menu>

<router-outlet name="toolbar"></router-outlet>
